// A short two-tone chime for the in-app (live tab) alert, synthesized with the
// Web Audio API rather than shipped as an audio file — no asset to go missing,
// no network fetch on first play, and the exact same sound everywhere the app
// runs.
//
// This is ONLY for the WebSocket path (someone has the tab open right now).
// The OS push path's sound is NOT this — it's whatever the phone's own
// notification sound is, played by the operating system itself when
// showNotification() fires in the service worker; a page's Audio/WebAudio API
// cannot run at all while the tab is closed, which is exactly why push exists.
let ctx = null;

function getContext() {
    if (!ctx) {
        const AudioCtx = window.AudioContext || window.webkitAudioContext;
        if (!AudioCtx) return null;
        ctx = new AudioCtx();
    }
    return ctx;
}

/**
 * Plays a bright two-note chime (like a doorbell, not an alarm — this fires
 * for routine status updates, not emergencies). Safe to call speculatively:
 * silently does nothing if Web Audio isn't available, and resumes a
 * browser-suspended context first (Chrome suspends AudioContext until the
 * page has seen a user gesture — by the time this fires the user has already
 * logged in and clicked around, so resume() succeeds immediately rather than
 * needing a fresh click).
 */
export function playAlertChime() {
    const audioCtx = getContext();
    if (!audioCtx) return;

    const start = () => {
        const now = audioCtx.currentTime;
        [[880, now, 0.14], [1318.5, now + 0.12, 0.18]].forEach(([freq, at, dur]) => {
            const osc = audioCtx.createOscillator();
            const gain = audioCtx.createGain();
            osc.type = 'sine';
            osc.frequency.value = freq;
            gain.gain.setValueAtTime(0.0001, at);
            gain.gain.exponentialRampToValueAtTime(0.22, at + 0.02);
            gain.gain.exponentialRampToValueAtTime(0.0001, at + dur);
            osc.connect(gain).connect(audioCtx.destination);
            osc.start(at);
            osc.stop(at + dur + 0.02);
        });
    };

    if (audioCtx.state === 'suspended') {
        audioCtx.resume().then(start).catch(() => {});
    } else {
        start();
    }
}
